import { Box, Loader, Briefcase, Grid, Archive, Truck } from 'react-feather'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Reactstrap Imports
import { Card, CardHeader, CardBody, CardText, Row, Col } from 'reactstrap'
import { Loading } from '@components/content-loader' // Content Loader from components

const InboundStatsVertical = ({data, loading, style }) => {
  const mainColors = ['primary', 'warning', 'info', 'danger', 'success', 'secondary']
  const icons = [<Loader />, <Truck />, <Box />, <Archive />, <Briefcase />, <Grid />]
  const formatter = new Intl.NumberFormat('en-US')

  const totals = [
    { title: "Total MT", subTitle: data.totalMT, color: mainColors[0], icon: icons[0] },
    { title: "Total Containers", subTitle: data.totalContainer, color: mainColors[1], icon: icons[1] },
    { title: "Total Units", subTitle: data.totalUnits, color: mainColors[2], icon: icons[2] },
    { title: "BGR (MT)", subTitle: data.bgrmt, color: mainColors[3], icon: icons[3] },
    { title: "BAG (MT)", subTitle: data.bagmt, color: mainColors[4], icon: icons[4] },
    { title: "BLK (MT)", subTitle: data.blkmt, color: mainColors[5], icon: icons[5] }
  ]

  const RenderData = () => {
    return totals.map((item, index) => (
      <Row key={index} style={{ marginBottom: '1.5rem', alignItems: 'center' }}>
        <Col
          xs="3"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Avatar
            color={item.color}
            icon={item.icon}
            style={{
              width: '60px',
              height: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%'
            }}
          />
        </Col>
        <Col xs="9">
          {loading ? (
            <Loading foregroundColor={'#28c76f'} backgroundColor={"#eaeced"} />
          ) : (
            <div>
              <h4 style={{ fontSize: '1.5rem', fontWeight: 'bold', margin: '0 0 0.5rem 0' }}>
                {formatter.format(item.subTitle)}
              </h4>
              <CardText style={{ fontSize: '1rem', margin: 0 }}>
                {item.title}
              </CardText>
            </div>
          )}
        </Col>
      </Row>
    ))
  }

  return (
    <Card style={{ borderRadius: '15px', ...style }}>
      <CardHeader style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '1rem' }}>
        {/* <CardText style={{ fontSize: '1.25rem', margin: 0 }}>Current</CardText> */}
      </CardHeader>
      <CardBody style={{ padding: '1.5rem' }}>
        <RenderData />
      </CardBody>
    </Card>
  )
}

export default InboundStatsVertical